
import { useState, useEffect } from 'react';
import Icon from '../../../components/ui/AppIcon';
import AppImage from '../../../components/ui/AppImage';
import Enquiry_Form_Modal from '../../enquiry_form_modal/Enquiry_Form_Modal';

interface Specialization {
  id: string;
  name: string;
  icon: string;
  description: string;
  careerPaths: string[];
  avgSalary: string;
  topRoles: string[];
  image: string;
  alt: string;
}

const SpecializationSelector = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [selectedSpec, setSelectedSpec] = useState<string>('marketing');

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const specializations: Specialization[] = [
  {
    id: 'marketing',
    name: 'Marketing Management',
    icon: 'MegaphoneIcon',
    description: 'Master digital marketing, brand management, and consumer behavior',
    careerPaths: ['Digital Marketing Manager', 'Brand Manager', 'Marketing Director'],
    avgSalary: '₹8-15 LPA',
    topRoles: ['CMO', 'Growth Manager', 'Product Marketing Lead'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_11b3ce77a-1764641104635.png",
    alt: 'Marketing team analyzing digital campaign data on large monitor in modern office'
  },
  {
    id: 'finance',
    name: 'Finance Management',
    icon: 'BanknotesIcon',
    description: 'Learn financial analysis, investment strategies, and corporate finance',
    careerPaths: ['Financial Analyst', 'Investment Manager', 'CFO'],
    avgSalary: '₹10-18 LPA',
    topRoles: ['Finance Director', 'Treasury Manager', 'Risk Manager'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1186fca07-1764651381572.png",
    alt: 'Finance professional analyzing stock market charts and financial reports on dual monitors'
  },
  {
    id: 'hr',
    name: 'Human Resource Management',
    icon: 'UserGroupIcon',
    description: 'Develop expertise in talent management, organizational behavior, and HR analytics',
    careerPaths: ['HR Manager', 'Talent Acquisition Head', 'CHRO'],
    avgSalary: '₹7-14 LPA',
    topRoles: ['VP HR', 'People Operations Lead', 'Learning & Development Head'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_18127f02f-1764714866990.png",
    alt: 'HR manager conducting interview with candidate in bright modern office space'
  },
  {
    id: 'operations',
    name: 'Operations Management',
    icon: 'CogIcon',
    description: 'Master supply chain, logistics, and process optimization',
    careerPaths: ['Operations Manager', 'Supply Chain Head', 'COO'],
    avgSalary: '₹9-16 LPA',
    topRoles: ['VP Operations', 'Plant Manager', 'Logistics Director'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12d1ce0ca-1764637482620.png",
    alt: 'Operations team reviewing warehouse logistics and supply chain workflow on tablets'
  },
  {
    id: 'it',
    name: 'IT Management',
    icon: 'ComputerDesktopIcon',
    description: 'Combine technology and business strategy for digital transformation',
    careerPaths: ['IT Manager', 'CTO', 'Digital Transformation Lead'],
    avgSalary: '₹12-20 LPA',
    topRoles: ['VP Technology', 'Enterprise Architect', 'IT Director'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_112cf8eca-1764668943722.png",
    alt: 'IT professionals collaborating on software development project with multiple screens'
  },
  {
    id: 'entrepreneurship',
    name: 'Entrepreneurship',
    icon: 'RocketLaunchIcon',
    description: 'Learn startup strategies, business planning, and innovation management',
    careerPaths: ['Startup Founder', 'Business Consultant', 'Innovation Manager'],
    avgSalary: '₹10-25 LPA',
    topRoles: ['CEO', 'Business Development Head', 'Venture Partner'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_136ebe11f-1764672595819.png",
    alt: 'Entrepreneur presenting business plan to investors in modern startup office'
  },


    {
    id: 'project-management',
    name: 'Project Management',
    icon: 'ClipboardDocumentCheckIcon',
    description: 'Learn planning, execution, and monitoring of projects across industries',
    careerPaths: [
      'Project Manager',
      'Program Manager',
      'Scrum Master',
      'Delivery Manager',
      'PMO Analyst'
    ],
    avgSalary: '₹9-18 LPA',
    topRoles: [
      'Senior Project Manager',
      'Project Director',
      'Head of PMO',
      'Portfolio Manager'
    ],
    image: 'https://img.rocket.new/generatedImages/project_management.png',
    alt: 'Project manager reviewing project roadmap on digital board'
  },
  {
    id: 'hospital-administration',
    name: 'Hospital Administration & Healthcare Management',
    icon: 'BuildingOfficeIcon',
    description: 'Develop skills in healthcare operations, policy, and hospital management',
    careerPaths: [
      'Hospital Administrator',
      'Healthcare Operations Manager',
      'Medical Services Manager',
      'Healthcare Consultant',
      'Quality & Compliance Manager'
    ],
    avgSalary: '₹8-20 LPA',
    topRoles: [
      'Director of Hospital Operations',
      'Chief Administrative Officer',
      'Healthcare Business Head',
      'Regional Healthcare Manager'
    ],
    image: 'https://img.rocket.new/generatedImages/hospital_admin.png',
    alt: 'Hospital administrator managing healthcare staff and hospital workflow'
  },
  {
    id: 'international-business',
    name: 'International Business Management',
    icon: 'GlobeAltIcon',
    description: 'Learn global business strategy, trade, and cross-cultural management',
    careerPaths: [
      'International Business Manager',
      'Export–Import Manager',
      'Global Supply Chain Manager',
      'International Sales Manager',
      'Trade Compliance Analyst'
    ],
    avgSalary: '₹10-22 LPA',
    topRoles: [
      'VP International Business',
      'Global Operations Head',
      'Country Manager',
      'Director – Global Markets'
    ],
    image: 'https://img.rocket.new/generatedImages/international_business.png',
    alt: 'Business professional analyzing international market trends'
  },
  {
    id: 'fintech-management',
    name: 'Fintech Management',
    icon: 'CurrencyDollarIcon',
    description: 'Understand digital finance, blockchain, and financial technology innovation',
    careerPaths: [
      'Fintech Product Manager',
      'Digital Banking Manager',
      'Payments Strategy Manager',
      'Blockchain Business Analyst',
      'Fintech Operations Manager'
    ],
    avgSalary: '₹12-25 LPA',
    topRoles: [
      'VP Fintech',
      'Head of Digital Banking',
      'Fintech Strategy Lead',
      'Chief Innovation Officer'
    ],
    image: 'https://img.rocket.new/generatedImages/fintech_management.png',
    alt: 'Fintech manager working on blockchain and financial apps'
  },

    {
    id: 'business-analytics',
    name: 'Business Analytics Management',
    icon: 'ChartBarIcon',
    description: 'Leverage data analytics, business intelligence, and decision science to drive strategy',
    careerPaths: [
      'Business Analyst',
      'Data Analyst',
      'Analytics Consultant',
      'BI Manager',
      'Decision Science Analyst'
    ],
    avgSalary: '₹10-22 LPA',
    topRoles: [
      'Head of Analytics',
      'Chief Data Officer',
      'Analytics Director',
      'Strategy & Insights Lead'
    ],
    image: 'https://img.rocket.new/generatedImages/business_analytics.png',
    alt: 'Business analyst analyzing data dashboards and performance metrics'
  },
  {
    id: 'ai-ml-management',
    name: 'AI & ML Management',
    icon: 'CpuChipIcon',
    description: 'Manage artificial intelligence initiatives, machine learning strategy, and AI-driven products',
    careerPaths: [
      'AI Product Manager',
      'Machine Learning Manager',
      'AI Strategy Consultant',
      'Data Science Manager',
      'Intelligent Systems Manager'
    ],
    avgSalary: '₹15-30 LPA',
    topRoles: [
      'Head of AI',
      'Chief AI Officer',
      'Director of Machine Learning',
      'VP – Data & AI'
    ],
    image: 'https://img.rocket.new/generatedImages/ai_ml_management.png',
    alt: 'AI professionals working on machine learning models and neural networks'
  },
  {
    id: 'logistics-supply-chain',
    name: 'Logistics, Materials & Supply Chain Management',
    icon: 'TruckIcon',
    description: 'Optimize logistics, materials planning, and end-to-end supply chain operations',
    careerPaths: [
      'Logistics Manager',
      'Supply Chain Manager',
      'Materials Manager',
      'Warehouse Operations Manager',
      'Demand Planning Analyst'
    ],
    avgSalary: '₹8-18 LPA',
    topRoles: [
      'Supply Chain Director',
      'Head of Logistics',
      'VP Supply Chain',
      'Chief Operations Officer'
    ],
    image: 'https://img.rocket.new/generatedImages/logistics_supply_chain.png',
    alt: 'Logistics and supply chain professionals managing warehouse and transportation network'
  },
  {
    id: 'blockchain-management',
    name: 'Blockchain Management',
    icon: 'CubeTransparentIcon',
    description: 'Manage blockchain solutions, decentralized platforms, and crypto-based business models',
    careerPaths: [
      'Blockchain Product Manager',
      'Blockchain Business Analyst',
      'Crypto Operations Manager',
      'Web3 Strategy Consultant',
      'Decentralized Systems Manager'
    ],
    avgSalary: '₹12-28 LPA',
    topRoles: [
      'Head of Blockchain',
      'Web3 Director',
      'Chief Blockchain Officer',
      'VP – Digital Assets'
    ],
    image: 'https://img.rocket.new/generatedImages/blockchain_management.png',
    alt: 'Blockchain professional visualizing decentralized ledger and smart contracts'
  },
  {
    id: 'digital-marketing',
    name: 'Digital Marketing Management',
    icon: 'MegaphoneIcon',
    description: 'Lead digital campaigns across SEO, social media, paid ads, and marketing automation',
    careerPaths: [
      'Digital Marketing Manager',
      'SEO Manager',
      'Performance Marketing Manager',
      'Social Media Strategist',
      'Growth Marketing Manager'
    ],
    avgSalary: '₹7-20 LPA',
    topRoles: [
      'Head of Digital Marketing',
      'Growth Director',
      'Chief Marketing Officer',
      'VP – Marketing'
    ],
    image: 'https://img.rocket.new/generatedImages/digital_marketing.png',
    alt: 'Digital marketing team optimizing online campaigns and analytics'
  },
  {
    id: 'agribusiness-management',
    name: 'Agribusiness Management',
    icon: 'TruckIcon',
    description: 'Manage agri-value chains, food supply systems, and agri-enterprise operations',
    careerPaths: [
      'Agribusiness Manager',
      'Agri Supply Chain Manager',
      'Rural Marketing Manager',
      'Agri Operations Manager',
      'Food Processing Manager'
    ],
    avgSalary: '₹6-15 LPA',
    topRoles: [
      'Head of Agribusiness',
      'Agri Enterprise Director',
      'CEO – Agri Ventures',
      'Supply Chain Head – Agri'
    ],
    image: 'https://img.rocket.new/generatedImages/agribusiness_management.png',
    alt: 'Agribusiness manager overseeing agricultural supply chain and farm operations'
  }
];


  const selectedSpecialization = specializations.find((spec) => spec.id === selectedSpec);

  
   const [showStickyModal, setShowStickyModal] = useState(false);

  return (
    <section id="specializations" className="py-20 bg-gradient-to-br from-primary/5 to-secondary/5">
      <div className="max-w-content mx-auto px-section-margin">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">
            Choose Your MBA Specialization
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Select from 6 industry-focused specializations designed to accelerate your career growth
          </p>
        </div>

        {/* Specialization Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {specializations.map((spec) =>
          <button
            key={spec.id}
            onClick={() => isHydrated && setSelectedSpec(spec.id)}
            className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-semibold transition-default ${
            selectedSpec === spec.id ?
            'bg-primary text-primary-foreground shadow-cta' :
            'bg-background text-text-primary border border-border hover:border-primary hover:bg-primary/5'}`
            }>

              <Icon name={spec.icon as any} size={20} variant={selectedSpec === spec.id ? 'solid' : 'outline'} />
              <span className="hidden sm:inline">{spec.name}</span>
              <span className="sm:hidden">{spec.name.split(' ')[0]}</span>
            </button>
          )}
        </div>

        {/* Selected Specialization Details */}
        {selectedSpecialization &&
        <div className="bg-background rounded-2xl shadow-xl overflow-hidden border border-border">
            <div className="grid lg:grid-cols-2 gap-0">
              {/* Image Section */}
              <div className="relative h-64 lg:h-auto overflow-hidden career_img_holder">
                <AppImage
                src={selectedSpecialization.image}
                alt={selectedSpecialization.alt}
                className="w-full h-full object-cover" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-6 left-6 right-6">
                  <div className="flex items-center space-x-3 mb-2">
                    <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                      <Icon name={selectedSpecialization.icon as any} size={24} className="text-primary-foreground" variant="solid" />
                    </div>
                    <h3 className="text-2xl font-bold text-white">{selectedSpecialization.name}</h3>
                  </div>
                </div>
              </div>

              {/* Content Section */}
              <div className="p-4 lg:p-12">
                <p className="text-lg text-text-secondary mb-8">{selectedSpecialization.description}</p>

                <div className="space-y-6">
                  {/* Career Paths */}
                  <div>
                    <div className="flex items-center space-x-2 mb-3">
                      <Icon name="BriefcaseIcon" size={20} className="text-primary" variant="solid" />
                      <h4 className="font-bold text-text-primary">Career Paths</h4>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {selectedSpecialization.careerPaths.map((path, index) =>
                    <span key={index} className="bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-medium">
                          {path}
                        </span>
                    )}
                    </div>
                  </div>

                  {/* Average Salary */}
                  <div className="bg-success/10 border border-success/20 rounded-lg p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-2">
                        <Icon name="CurrencyRupeeIcon" size={20} className="text-success" variant="solid" />
                        <span className="text-sm text-text-secondary">Average Salary Range</span>
                      </div>
                      <span className="text-xl font-bold text-success">{selectedSpecialization.avgSalary}</span>
                    </div>
                  </div>

                  {/* Top Roles */}
                  <div>
                    <div className="flex items-center space-x-2 mb-3">
                      <Icon name="TrophyIcon" size={20} className="text-accent" variant="solid" />
                      <h4 className="font-bold text-text-primary">Top Leadership Roles</h4>
                    </div>
                    <ul className="space-y-2">
                      {selectedSpecialization.topRoles.map((role, index) =>
                    <li key={index} className="flex items-center space-x-2">
                          <Icon name="CheckCircleIcon" size={16} className="text-success" variant="solid" />
                          <span className="text-text-primary">{role}</span>
                        </li>
                    )}
                    </ul>
                  </div>
                </div>

                <button className="w-full mt-8 bg-accent text-accent-foreground py-4 rounded-lg font-bold shadow-cta hover:bg-accent/90 transition-default" onClick={() => {setShowStickyModal(true)}}>
                  Get Career Guidance for {selectedSpecialization.name}
                </button>
              </div>
            </div>
          </div>
        }

        {/* Help Section */}
        {/* <div className="mt-12 bg-background rounded-xl p-8 border border-border text-center">
          <Icon name="QuestionMarkCircleIcon" size={48} className="text-primary mx-auto mb-4" variant="solid" />
          <h3 className="text-xl font-bold text-text-primary mb-2">Not Sure Which Specialization to Choose?</h3>
          <p className="text-text-secondary mb-6">
            Our expert counselors will help you select the right specialization based on your career goals and experience
          </p>
          <button className="bg-secondary text-secondary-foreground px-8 py-3 rounded-lg font-semibold hover:bg-secondary/90 transition-default">
            Talk to Career Counselor
          </button>
        </div> */}
      </div>

      
        <Enquiry_Form_Modal
          show={showStickyModal}
          onHide={() => {
            setShowStickyModal(false);
          }}
        />
    </section>);

};

export default SpecializationSelector;